import { OnInit, OnChanges, AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { Component, Input, ElementRef, QueryList, ViewChildren, Output, EventEmitter } from '@angular/core';
import { TravelService, SeatAllocation, SeatStatus } from '../../services/travel.service';
import { StopItem, ReferenceDataService } from '../../services/reference-data.service';
import { Sector, Booking } from '../../models/booking.model';
import { GoogleMapComponent } from 'app/shared/components/google-map/google-map.component';
import { SeatAllocationsComponent } from 'app/shared/components/seat-allocations/seat-allocations.component';
import { FeatureService, Feature } from 'app/shared/services/feature.service';

declare var $:any;

@Component({
    selector: 'gaweb-trip-details',
    templateUrl: `./trip-details.component.html`
})
export class TripDetailsComponent implements OnInit, AfterViewInit {
    @Input() sector: any;
    @Input() readonly: any;
    @Input() booking: Booking;
    @Input() travelGuid: string;
    @Output() onSeatsUpdated: EventEmitter<Array<SeatAllocation>> = new EventEmitter();

    @ViewChildren(GoogleMapComponent) googleMap: QueryList<GoogleMapComponent>;
    @ViewChildren(SeatAllocationsComponent) seatAllocations: QueryList<SeatAllocationsComponent>;

    
    public mapEnabled = true;

    constructor(private travelService: TravelService,
                private referenceDataService: ReferenceDataService,
                private componentElement: ElementRef,
                private featureService: FeatureService) {}
    ngOnInit(): void {
        this.mapEnabled = !this.featureService.GetFeatureStatus(Feature.HideGoogleMaps);
        
    this.sector.mapView = null;
    if (this.sector.timetable != null) {
        this.sector.fullRoute = this.calculateFullRoute(this.sector.timetable);
        this.sector.serviceList = this.calculateServiceList(this.sector.timetable);
    }
    this.sector.showMap = (inputRo) => {
        this.sector.mapView = true;
        this.checkMaps(inputRo);
    };
    this.sector.ServiceHasWifi = (service) => {
        if (this.sector.WifiSectors.indexOf(service) > -1){
            return true;
        } else {
            return false;
        }
     };
    }

    ngAfterViewInit(): void {
        $('.coach-icon').tooltip();
    }

    onNewSeats(seats){
        this.onSeatsUpdated.emit(seats);
    }

    calculateServiceList(data) {
        const serviceList = []
        {
            data.forEach(service => {
                serviceList.push(service[0].CompanyCode.toUpperCase() + service[0].ServiceNumber);
            });
        }
        return serviceList;
    }

    checkMaps(ro: any) {
        // Wait until map is ready.
        if (this.googleMap) {
            this.googleMap.forEach((gmap) => {
                ro.mapReady = gmap.mapReady;
                gmap.refreshMap();
        });
        } else {
            setTimeout(() => {
                this.checkMaps(ro);
            }, 250);
        }
    }


    calculateFullRoute(data) {
        const fullRoute = [];
        data.forEach(service => {

            service.forEach(stop => {
                fullRoute.push(stop);
            });

            if (fullRoute.length > 1) {
                fullRoute[fullRoute.length - service.length].departing = true;
                fullRoute[fullRoute.length - 1].terminating = true;
            }
        });
        return fullRoute;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/trip-details/trip-details.component.ts